import axios from '../../axios';

const path = 'gateways';

const service = {
  getAllGateways() {
    return axios({ method: 'get', url: `${path}/all` });
  },

  getGateways(params) {
    return axios({ method: 'get', url: path, params });
  },

  fetchGateway(id) {
    return axios({ method: 'get', url: `${path}/${id}` });
  },

  fetchAdminGateway(id) {
    return axios({ method: 'get', url: `${path}/admin/${id}` });
  },

  createNewGateway(payload) {
    return axios({ method: 'post', url: path, data: payload });
  },

  searchGateways(params) {
    return axios({ method: 'get', url: `${path}/search`, params });
  },

  updateGateway({ id, data }) {
    return axios({ method: 'put', url: `${path}/${id}`, data });
  },

  deleteGateway({ ids }) {
    return axios({ method: 'delete', url: `${path}/archive`, data: { ids } });
  }
};

export default service;
